/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export const GET_APPS_PERFORMANCE_RESPONSE = {
	title: "My running Apps - CO2e Emissions",
	lineSeries: [
		{
			name: "AWS German Cluster",
			linePoints: [
				{ name: "2025-01-01T00:00:00Z", value: 15, unit: "kgCO2e" },
				{ name: "2025-02-01T00:00:00Z", value: 18, unit: "kgCO2e" },
				{ name: "2025-03-01T00:00:00Z", value: 20, unit: "kgCO2e" },
				{ name: "2025-04-01T00:00:00Z", value: 22, unit: "kgCO2e" },
				{ name: "2025-05-01T00:00:00Z", value: 25, unit: "kgCO2e" },
				{ name: "2025-06-01T00:00:00Z", value: 23, unit: "kgCO2e" },
				{ name: "2025-07-01T00:00:00Z", value: 20, unit: "kgCO2e" },
				{ name: "2025-08-01T00:00:00Z", value: 18, unit: "kgCO2e" },
				{ name: "2025-09-01T00:00:00Z", value: 25, unit: "kgCO2e" },
				{ name: "2025-10-01T00:00:00Z", value: 22, unit: "kgCO2e" },
				{ name: "2025-11-01T00:00:00Z", value: 20, unit: "kgCO2e" },
				{ name: "2025-12-01T00:00:00Z", value: 23, unit: "kgCO2e" }
			]
		},
		{
			name: "Azure Spain Platform",
			linePoints: [
				{ name: "2025-01-01T00:00:00Z", value: 30, unit: "kgCO2e" },
				{ name: "2025-02-01T00:00:00Z", value: 32, unit: "kgCO2e" },
				{ name: "2025-03-01T00:00:00Z", value: 35, unit: "kgCO2e" },
				{ name: "2025-04-01T00:00:00Z", value: 38, unit: "kgCO2e" },
				{ name: "2025-05-01T00:00:00Z", value: 36, unit: "kgCO2e" },
				{ name: "2025-06-01T00:00:00Z", value: 34, unit: "kgCO2e" },
				{ name: "2025-07-01T00:00:00Z", value: 32, unit: "kgCO2e" },
				{ name: "2025-08-01T00:00:00Z", value: 35, unit: "kgCO2e" },
				{ name: "2025-09-01T00:00:00Z", value: 38, unit: "kgCO2e" },
				{ name: "2025-10-01T00:00:00Z", value: 36, unit: "kgCO2e" },
				{ name: "2025-11-01T00:00:00Z", value: 34, unit: "kgCO2e" },
				{ name: "2025-12-01T00:00:00Z", value: 37, unit: "kgCO2e" }
			]
		},
		{
			name: "Dummy eCommerce",
			linePoints: [
				{ name: "2025-01-01T00:00:00Z", value: 10, unit: "kgCO2e" },
				{ name: "2025-02-01T00:00:00Z", value: 12, unit: "kgCO2e" },
				{ name: "2025-03-01T00:00:00Z", value: 15, unit: "kgCO2e" },
				{ name: "2025-04-01T00:00:00Z", value: 20, unit: "kgCO2e" },
				{ name: "2025-05-01T00:00:00Z", value: 18, unit: "kgCO2e" },
				{ name: "2025-06-01T00:00:00Z", value: 16, unit: "kgCO2e" },
				{ name: "2025-07-01T00:00:00Z", value: 14, unit: "kgCO2e" },
				{ name: "2025-08-01T00:00:00Z", value: 18, unit: "kgCO2e" },
				{ name: "2025-09-01T00:00:00Z", value: 60, unit: "kgCO2e" },
				{ name: "2025-10-01T00:00:00Z", value: 50, unit: "kgCO2e" },
				{ name: "2025-11-01T00:00:00Z", value: 25, unit: "kgCO2e" },
				{ name: "2025-12-01T00:00:00Z", value: 40, unit: "kgCO2e" }
			]
		},
		{
			name: "Fatturazione",
			linePoints: [
				{ name: "2025-01-01T00:00:00Z", value: 5, unit: "kgCO2e" },
				{ name: "2025-02-01T00:00:00Z", value: 7, unit: "kgCO2e" },
				{ name: "2025-03-01T00:00:00Z", value: 9, unit: "kgCO2e" },
				{ name: "2025-04-01T00:00:00Z", value: 11, unit: "kgCO2e" },
				{ name: "2025-05-01T00:00:00Z", value: 10, unit: "kgCO2e" },
				{ name: "2025-06-01T00:00:00Z", value: 8, unit: "kgCO2e" },
				{ name: "2025-07-01T00:00:00Z", value: 6, unit: "kgCO2e" },
				{ name: "2025-08-01T00:00:00Z", value: 8, unit: "kgCO2e" },
				{ name: "2025-09-01T00:00:00Z", value: 10, unit: "kgCO2e" },
				{ name: "2025-10-01T00:00:00Z", value: 9, unit: "kgCO2e" },
				{ name: "2025-11-01T00:00:00Z", value: 7, unit: "kgCO2e" },
				{ name: "2025-12-01T00:00:00Z", value: 9, unit: "kgCO2e" }
			]
		},
		{
			name: "GCP Application",
			linePoints: [
				{ name: "2025-01-01T00:00:00Z", value: 20, unit: "kgCO2e" },
				{ name: "2025-02-01T00:00:00Z", value: 22, unit: "kgCO2e" },
				{ name: "2025-03-01T00:00:00Z", value: 25, unit: "kgCO2e" },
				{ name: "2025-04-01T00:00:00Z", value: 28, unit: "kgCO2e" },
				{ name: "2025-05-01T00:00:00Z", value: 26, unit: "kgCO2e" },
				{ name: "2025-06-01T00:00:00Z", value: 24, unit: "kgCO2e" },
				{ name: "2025-07-01T00:00:00Z", value: 22, unit: "kgCO2e" },
				{ name: "2025-08-01T00:00:00Z", value: 25, unit: "kgCO2e" },
				{ name: "2025-09-01T00:00:00Z", value: 28, unit: "kgCO2e" },
				{ name: "2025-10-01T00:00:00Z", value: 26, unit: "kgCO2e" },
				{ name: "2025-11-01T00:00:00Z", value: 24, unit: "kgCO2e" },
				{ name: "2025-12-01T00:00:00Z", value: 27, unit: "kgCO2e" }
			]
		}
	]
};

export const GET_TOTAL_CO2_RESPONSE = {
	value: 5.12,
	unit: "kWh"
};

export const GET_WORST_10_APPS_RESPONSE = {
	title: "Highest environmental impact - Apps",
	barSeries: [
		{
			name: "Environmental Impact",
			bars: [
				{
					name: "GCP Application",
					value: 85,
					unit: "kgCO2"
				},
				{
					name: "AWS German Cluster",
					value: 75,
					unit: "kgCO2"
				},
				{
					name: "Azure Spain Platform",
					value: 65,
					unit: "kgCO2"
				},
				{
					name: "Dummy eCommerce",
					value: 60,
					unit: "kgCO2"
				},
				{
					name: "Fatturazione",
					value: 52,
					unit: "kgCO2"
				},
				{
					name: "APP name max25digt",
					value: 40,
					unit: "kgCO2"
				},
				{
					name: "APP name max25digt",
					value: 35,
					unit: "kgCO2",
					tenantRegion: true
				},
				{
					name: "APP name max25digt",
					value: 30,
					unit: "kgCO2",
					tenantRegion: true
				},
				{
					name: "APP name max25digt",
					value: 25,
					unit: "kgCO2",
					tenantRegion: true
				}
			]
		}
	]
};

export const GET_WORST_10_LAYERS_RESPONSE = {
	title: "Highest environmental impact - Layers per App",
	barSeries: [
		{
			name: "Environmental Impact",
			bars: [
				{
					name: "GCP Application",
					value: 85,
					unit: "kgCO2"
				},
				{
					name: "AWS German Cluster",
					value: 75,
					unit: "kgCO2"
				},
				{
					name: "Azure Spain Platform",
					value: 65,
					unit: "kgCO2"
				},
				{
					name: "Dummy eCommerce",
					value: 60,
					unit: "kgCO2"
				},
				{
					name: "Fatturazione",
					value: 52,
					unit: "kgCO2"
				},
				{
					name: "APP name max25digt",
					value: 40,
					unit: "kgCO2"
				},
				{
					name: "APP name max25digt",
					value: 35,
					unit: "kgCO2",
					tenantRegion: true
				},
				{
					name: "APP name max25digt",
					value: 30,
					unit: "kgCO2",
					tenantRegion: true
				},
				{
					name: "APP name max25digt",
					value: 25,
					unit: "kgCO2",
					tenantRegion: true
				}
			]
		}
	]
};
